import React from "react";
import SolutionDetail from "./Components/SolutionDetail";
import EducationImage from "../../assets/img/2149901782.webp";
import {
  FaAndroid,
  FaApple,
  FaAppStore,
  FaBuilding,
  FaDownload,
  FaPeopleCarry,
  FaSchool,
  FaSearch,
  FaTableTennis,
  FaWindows,
} from "react-icons/fa";
import { LucidePartyPopper, School } from "lucide-react";
import IntlMessages from "../../intl/IntlMessages";
import { FiMessageCircle } from "react-icons/fi";

const EducationSolution = () => {
  const solutionData = {
    title: <IntlMessages id="web.website" />,
    category: <IntlMessages id="web.category" />,
    description: <IntlMessages id="web.description" />,
    imageBg: `url(${EducationImage})`,
    features: [
      {
        icon: <FaBuilding size={38} />,
        title: <IntlMessages id="realEstate.services" />,
        description: <IntlMessages id="web.realEstate" />,
      },
      {
        icon: <LucidePartyPopper size={38} />,
        title: <IntlMessages id="eventManagement.title" />,
        description: <IntlMessages id="web.management" />,
      },
      {
        icon: <LucidePartyPopper size={38} />,
        title: <IntlMessages id="itServices.title" />,
        description: <IntlMessages id="web.describ" />,
      },
      {
        icon: <FaBuilding size={38} />,
        title: <IntlMessages id="content.btp" />,
        description: <IntlMessages id="content.civilDescription" />,
      },
      {
        icon: <FiMessageCircle size={38} />,
        title: <IntlMessages id="expertise.socialPlatform" />,
        description: <IntlMessages id="content.socialChatDescription" />,
      },
    ],
    benefits: [
      <IntlMessages id="web.automatisation" />,
      <IntlMessages id="web.time" />,
      <IntlMessages id="web.communication" />,
      <IntlMessages id="web.optimized" />,
      <IntlMessages id="web.details" />,
      <IntlMessages id="web.accessibility" />,
      <IntlMessages id="web.security" />,
      <IntlMessages id="web.confidentiality" />,
    ],
    targetAudience: [
      {
        icon: <FaPeopleCarry size={35} />,
        title: <IntlMessages id="web.physical" />,
        description: <IntlMessages id="web.user" />,
      },
      {
        icon: <FaSchool size={35} />,
        title: <IntlMessages id="web.school" />,
        description: <IntlMessages id="web.excurssion" />,
      },
      {
        icon: <FaTableTennis size={35} />,
        title: <IntlMessages id="web.sport" />,
        description: <IntlMessages id="web.sportActivity" />,
      },
      {
        icon: <School size={35} />,
        title: <IntlMessages id="web.formationCenter" />,
        description: <IntlMessages id="web.center" />,
      },
      {
        icon: <FaSearch size={35} />,
        title: <IntlMessages id="userTypes.others" />,
        description:<IntlMessages id="web.software" />,
      },
    ],
    modules: [
      {
        title: <IntlMessages id="web.vision" />,
        features: [
          <IntlMessages id="software.digital" />,
          <IntlMessages id="software.employ" />,
          <IntlMessages id="software.payment" />,
          <IntlMessages id="software.persons" />,
          <IntlMessages id="software.audit" />,
          <IntlMessages id="software.synchrone" />,
        ],
      },
    ],
    customization: {
      description: <IntlMessages id="software.download" />,
      options: [
        {
          icon: <FaAndroid size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
        {
          icon: <FaAppStore size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
        {
          icon: <FaWindows size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
        {
          icon: <FaApple size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
      ],
    },
  };

  return <SolutionDetail {...solutionData} />;
};

export default EducationSolution;
